import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationComponent } from 'src/app/shared/component/pagination/pagination.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ReactiveFormsModule } from '@angular/forms';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AlphabetOnlyDirective } from './directive/alphabet-only.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReadmoreDirective } from './readmore.directive';
import { camelCaseToSpaceDirective } from './directive/camelCaseToSpace.directive';
import { CommonGalleryDialogComponent } from './common-gallery-dialog/common-gallery-dialog.component';
import { CommonFiltersComponent } from './common-filters/common-filters.component';
import { CommonDocumentUploadComponent } from '../pages/common-document-upload/common-document-upload.component';
import { CaseStudiesListComponent } from './case-studies-list/case-studies-list.component';
import { RouterModule } from '@angular/router';
import { TableComponent } from './table/table.component';
import { FilterComponent } from './filter/filter.component';
import { TableReactiveComponent } from './table-reactive/table-reactive.component';
import { LoanTableComponent } from './loan-table/loan-table.component';
import { WithdrawDialogueComponent } from './withdraw-dialogue/withdraw-dialogue.component';
import { ShardedTableComponent } from './sharded-table/sharded-table.component';
import { LoaderComponent } from './loader/loader.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DATE_LOCALE, MatOptionModule } from '@angular/material/core';
import { EmptyDialogComponent } from './empty-dialog/empty-dialog.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MatMenuModule } from '@angular/material/menu';
import { IndianCurrencyPipe } from './pipes/indian-currency.pipe';
import { IndianNumberWithoutDecimalPipe } from './pipes/indian-number-without-decimal.pipe';
import { IndianNumberWithDecimalPipe } from './pipes/indian-number-with-decimal.pipe';
// import { MdePopoverModule } from '@material-extended/mde';

@NgModule({
    declarations: [
        PaginationComponent,
        PaginatorComponent,
        DeleteDialogComponent,
        AlphabetOnlyDirective,
        ReadmoreDirective,
        camelCaseToSpaceDirective,
        CommonGalleryDialogComponent,
        CommonFiltersComponent,
        CommonDocumentUploadComponent,
        CaseStudiesListComponent,
        TableComponent,
        FilterComponent,
        TableReactiveComponent,
        WithdrawDialogueComponent,
        ShardedTableComponent,
        LoanTableComponent,
        LoaderComponent,
        EmptyDialogComponent,
        BreadcrumbComponent,
        IndianCurrencyPipe,
        IndianNumberWithoutDecimalPipe,
        IndianNumberWithDecimalPipe
    ],
    imports: [
        CommonModule,
        MatPaginatorModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatTooltipModule,
        RouterModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        // MdePopoverModule
        MatMenuModule
    ],
    exports: [
        PaginationComponent,
        PaginatorComponent,
        CommonModule,
        DeleteDialogComponent,
        AlphabetOnlyDirective,
        MatTooltipModule,
        ReadmoreDirective,
        camelCaseToSpaceDirective,
        CommonGalleryDialogComponent,
        CommonFiltersComponent,
        CommonDocumentUploadComponent,
        TableComponent,
        ShardedTableComponent,
        LoanTableComponent,
        WithdrawDialogueComponent,
        LoaderComponent,
        FilterComponent,
        EmptyDialogComponent,
        BreadcrumbComponent
    ],
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
    ]
})
export class SharedModule { }
